import { COUPON_TYPE } from 'src/app/product-capture/model/enums/coupon-type.enum';
import { ProductTypeEnum } from 'src/app/product-capture/model/enums/product-capture.enums';
import {
  PAYOFF_CALLABILITY_CALLABILITY,
  PAYOFF_CALLABILITY_CALL_EVENT_TYPE,
  PAYOFF_COUPON_PERFORMANCE_CALCULATION,
  PAYOFF_COUPON_RESTRIKE,
  PAYOFF_COUPON_CONVERSION,
  PAYOFF_COUPON_FREQUENCY,
  PAYOFF_COUPON_TYPE,
  PAYOFF_PARTICIPATION,
  PAYOFF_PARTICIPATION_BASE,
  PAYOFF_PARTICIPATION_BASE_TYPE,
  PAYOFF_PARTICIPATION_DOWNSIDE_TYPE,
  PAYOFF_PARTICIPATION_DOWNSIDE_LEVERAGE,
  PAYOFF_PARTICIPATION_UPSIDE_TYPE,
  SUMMARY_PERFORMANCE_TYPE,
  SUMMARY_REFERENCE_ENTITIES,
  SUMMARY_SETTLEMENT_TYPE,
  SUMMARY_UNDERLYING_ASSETS_GROUP,
  SUMMARY_FREQUENCY,
  PAYOFF_PARTICIPATION_CAPITAL_BASE_CAPITAL_BASE,
} from '../../mockups/consts/product-capture-field-selectors.consts';
import { DEFAULT_AND_SHOW_CAPITAL_BASE_VALUES } from './cln.settings';
import { PERFORMANCE_CALCULATION_KEYS } from 'src/app/product-capture/model/consts/performance-calculation.const';
import { PAYOFF_PARTICIPATION_FLOOR_STRIKE } from '../../mockups/consts/product-capture-field-selectors.consts';
import { PERFORMANCE_TYPE_KEYS } from 'src/app/product-capture/model/consts/performance-type.const';

export const PRDC_SETTINGS = {
  id: ProductTypeEnum.PRDC,
  label: 'PRDC',
  effects: [
    {
      formControlNames: [
        PAYOFF_PARTICIPATION_UPSIDE_TYPE,
        PAYOFF_PARTICIPATION_BASE_TYPE,
        PAYOFF_PARTICIPATION_DOWNSIDE_TYPE,
      ],
      selectValues: ['NONE'],
      readOnly: false,
    },
    {
      formControlNames: [PAYOFF_COUPON_TYPE],
      selectValues: [COUPON_TYPE.FIXED_TO_FORWARD],
      readOnly: false,
      hidden: false,
    },
    {
      formControlNames: [PAYOFF_COUPON_PERFORMANCE_CALCULATION],
      selectValues: [PERFORMANCE_CALCULATION_KEYS.FINAL_OVER_INITIAL],
    },
    {
      formControlNames: [PAYOFF_COUPON_RESTRIKE],
      selectValues: [false],
      readOnly: true,
    },
    {
      formControlNames: [
        SUMMARY_REFERENCE_ENTITIES,
        PAYOFF_COUPON_CONVERSION,
        PAYOFF_PARTICIPATION,
        PAYOFF_PARTICIPATION_BASE,
        PAYOFF_CALLABILITY_CALLABILITY,
      ],
      hidden: true,
    },
    {
      formControlNames: [PAYOFF_CALLABILITY_CALL_EVENT_TYPE],
      selectValues: ['NONE'],
      hidden: false,
      readOnly: false,
    },
    {
      formControlNames: [SUMMARY_PERFORMANCE_TYPE],
      selectValues: [PERFORMANCE_TYPE_KEYS.SINGLE],
      readOnly: true,
    },
    {
      formControlNames: [SUMMARY_SETTLEMENT_TYPE],
      selectValues: ['CASH'],
      readOnly: true,
    },
    {
      formControlNames: [PAYOFF_PARTICIPATION_DOWNSIDE_TYPE],
      selectValues: ['PUT'],
      hidden: false,
    },
    {
      formControlNames: [PAYOFF_PARTICIPATION_DOWNSIDE_LEVERAGE],
      readOnly: true,
    },
    {
      formControlNames: [PAYOFF_PARTICIPATION_FLOOR_STRIKE],
      hidden: true,
    },
    {
      formControlNames: [SUMMARY_FREQUENCY, PAYOFF_COUPON_FREQUENCY],
      readOnly: false,
    },
    {
      formControlNames: [SUMMARY_UNDERLYING_ASSETS_GROUP],
      hidden: false,
    },
    ...DEFAULT_AND_SHOW_CAPITAL_BASE_VALUES,
  ],
};
